/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AccountSelectionStrategy {
  FreightSimpleOnly = "FreightSimpleOnly",
  CustomerSpecificOnly = "CustomerSpecificOnly",
  FreightSimpleAndCustomerSpecific = "FreightSimpleAndCustomerSpecific",
}

export function instanceOfAccountSelectionStrategy(value: any): boolean {
  for (const key in AccountSelectionStrategy) {
    if (Object.prototype.hasOwnProperty.call(AccountSelectionStrategy, key)) {
      if (
        AccountSelectionStrategy[
          key as keyof typeof AccountSelectionStrategy
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AccountSelectionStrategyFromJSON(
  json: any,
): AccountSelectionStrategy {
  return AccountSelectionStrategyFromJSONTyped(json, false);
}

export function AccountSelectionStrategyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AccountSelectionStrategy {
  return json as AccountSelectionStrategy;
}

export function AccountSelectionStrategyToJSON(
  value?: AccountSelectionStrategy | null,
): any {
  return value as any;
}

export function AccountSelectionStrategyToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AccountSelectionStrategy {
  return value as AccountSelectionStrategy;
}
